import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseArray, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export enum MillPlanModelType {
  SOURCE_MODEL = 'Source Volume',
  CUT_MODEL = 'Cut Volume',
}

/**
 * An entry that represents a mill plan with position, rotation, and defect data
 */
export class GeckoMillPlan extends GeckoEntryBase<
  {
    cutModelId: string
    position: [number, number, number]
    rotation: [number, number, number]
    intersectingDefectPositions: Array<[number, number, number]>
  },
  {
    job: string
    site: string
    unit: string
    sandbox?: string
    component: string
    inspection: string
    'asset-model': string
    organization: string
  }
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    const position = parseArray<number>(json.data.position) ?? [0, 0, 0]
    const rotation = parseArray<number>(json.data.rotation) ?? [0, 0, 0]
    const intersectingDefectPositions =
      parseArray<[number, number, number]>(
        json.data.intersectingDefectPositions
      ) ?? []

    super(
      json,
      {
        cutModelId: parseString(json.data.cutModelId) ?? '',
        position: [position[0] ?? 0, position[1] ?? 0, position[2] ?? 0],
        rotation: [rotation[0] ?? 0, rotation[1] ?? 0, rotation[2] ?? 0],
        intersectingDefectPositions,
      },
      {
        job: parseString(json.tags.job) ?? '',
        site: parseString(json.tags.site) ?? '',
        unit: parseString(json.tags.unit) ?? '',
        sandbox: parseString(json.tags.sandbox) ?? '',
        component: parseString(json.tags.component) ?? '',
        inspection: parseString(json.tags.inspection) ?? '',
        'asset-model': parseString(json.tags['asset-model']) ?? '',
        organization: parseString(json.tags.organization) ?? '',
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a mill plan from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoMillPlan(json)
  }
}
